import React, { useState, useEffect } from 'react'
import axios from 'axios'
import AsideLoader from './aside_loader'

const App = () => {
    const [curation, setCuration] = useState([])
    const [mediumList, setMediumList] = useState([])
    const [loadData, setLoadData] = useState(false)

    const host = process.env.REACT_APP_SHOPPING_URL

    useEffect(() => {
        let _url = `${process.env.REACT_APP_API_URL}/front/v2/common/aside/`
        if (window.cate_id !== undefined) {
            _url += window.cate_id
        }
        fetchMedium(_url)
    }, [])

    const fetchMedium = async (url) => {
        try {
            const data = await axios.get(url)
            const { medium, curation } = data.data.result
            setCuration(curation)
            setMediumList(medium)
            setLoadData(true)
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <>
            {!loadData ? (
                <AsideLoader />
            ) : (
                <article className="mediumBar">
                    <figure className="medium">
                        <img
                            src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/tit_medium_aside.png`}
                            alt="미디엄"
                        />
                    </figure>

                    <div className="MdmBox">
                        <h2 className="MdTit blockobj">
                            <p>
                                미디엄 가이드
                                <br />
                                <span>구매의 기준을 바꾸다!</span>
                            </p>
                        </h2>

                        {mediumList.map((v, _k) => {
                            let href = host + '/list/' + v.cate_id + '/mguide'
                            let link = <a href={href} target="_blank" rel="noopener noreferrer">{v.subject}</a>
                            let newImg = ''
                            if (v.new_check.toString() === '1') {
                                newImg = (
                                    <span>
                                        <img
                                            src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/ico_new_red.gif`}
                                            alt="미디엄"
                                        />
                                    </span>
                                )
                            }

                            return [
                                <div className="MdmBoxCate" key={v.cate_id}>
                                    <strong className="BdTxt">
                                        {v.cate_name} {newImg}
                                    </strong>
                                    <p>{link}</p>
                                </div>,
                            ]
                        })}
                        {curation.length > 0 && (
                            <div className="MdmCuration">
                                <strong className="BdTxt">큐레이션</strong>
                                {curation.map((v, _k) => {
                                    if (v.lnk_youtube === undefined || v.lnk_youtube === '' || v.lnk_youtube === null)
                                        return true
                                    let href = process.env.REACT_APP_SHOPPING_URL + '/list/' + v.cat_id + '/curation/' + v.num_curation
                                    return (
                                        <a href={href} rel="noopener noreferrer">
                                            <div className="list" key={_k}>
                                                {v.lnk_youtube !== '-' && (
                                                <img src={`https://i.ytimg.com/vi/${v.lnk_youtube}/mqdefault.jpg`} className="youtube_img" alt={v.nm_curation}/>
                                                )}
                                                <p>{v.nm_curation}</p>
                                            </div>
                                        </a>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                </article>
            )}
        </>
    )
}

export default App



// WEBPACK FOOTER //
// ./src/aside_medium/App.js